export default __webpack_public_path__ + "static/stacked-column-a554248c8652e89c23987824797c08e9.png";